export default __webpack_public_path__ + "static/media/speech_bubble.29560e0e.png";